import { useSelector, useDispatch } from 'react-redux';
import { fetchTranferTypes, fetchTransferDetails, transferTypes } from '../actions/transferAction';


export function useTransfers(type) {
  const purchases = useSelector((state) => state.inventory[transferTypes[type]] );
  console.log({purchases});
  return purchases;
}


export function useFetchTransfers(type) {
  const dispatch = useDispatch();
    console.log('====================================');
    console.log("in fetch transfer", type);
    console.log('====================================');
    // Créez une fonction pour déclencher l'action fetchTransfers
    const fetchTransfersData = () => {
      console.log("in fetch transfer", type,"start");
      dispatch(fetchTranferTypes(type));
    };

  return fetchTransfersData;
}

export function useFetchTransfer(id) {
  const dispatch = useDispatch();

  // Créez une fonction pour déclencher l'action fetchTransfers
  const fetchTransfer = () => {
    dispatch(fetchTransferDetails(id));
  };

  return fetchTransfer;
}
